import './Icon_Link.css';
import {ReactComponent as LinkIcon} from './Icons_Attachment_Outline_Brand.svg';
function Icon_Link() {
  return (
    
      <div className='link-icon-container'>
         <LinkIcon className="link-icon-svg"/>
      </div>
            
  );
}

export default Icon_Link;